import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  closeServiceListDisplayModel,
  setPackageAndServiceModelTrue,
} from "../../store/slices/modalSlice";
import { Accordion } from "react-bootstrap";
import {
  setClickedCartId,
  setFromDeleteService,
  setModelTitle,
  setServiceListData,
} from "../../store/slices/IdSlice";
interface Service {
  serviceName: string;
  PriceAmount: number;
  PriceCurrency: string;
}

interface PackageItem {
  packageName?: string;
  serviceName?: string;
  totalPrice?: number;
  PriceAmount?: number;
  cartId: number;
  PriceCurrency: string;
  tags?: string[];
  services?: Service[];
  ServiceId?: number;
  selectedFilter?: string[];
  isPackage: boolean;
}

interface RootState {
  modal: {
    serviceListDisplayModel: boolean;
    serviceListData: PackageItem[];
  };
}
interface ServiceListDisplayModelProps {
  applicantLabel: string;
}

const ServiceListDisplayModel: React.FC<ServiceListDisplayModelProps> = ({
  applicantLabel,
}) => {
  const dispatch = useDispatch();

  const openModel = useSelector(
    (state: RootState) => state.modal.serviceListDisplayModel
  );
  const serviceListData = useSelector(
    (state: RootState) => state.modal.serviceListData
  );

  const [activeAccordionService, setActiveAccordionService] = useState<
    string | null
  >(null);

  const handleServiceAccordionToggle = (key: string) => {
    setActiveAccordionService(activeAccordionService === key ? null : key);
  };

  const OpenDeleteModel = (clickedCartId: number, title?: string) => {
    dispatch(setModelTitle(title));
    dispatch(setFromDeleteService(true));
    dispatch(setServiceListData(serviceListData));
    dispatch(setClickedCartId(clickedCartId));
    dispatch(setPackageAndServiceModelTrue());
    dispatch(closeServiceListDisplayModel());
  };

  const closeModel = () => {
    dispatch(closeServiceListDisplayModel());
  };

  return (
    <>
      <Modal
        scrollable
        centered
        show={openModel}
        onHide={closeModel}
        backdrop="static"
        className="mb-fix slide-from-bottom"
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body className=" rounded-top modal-body">
          <div className="displayDetails">
            <p className=" font-16 font-sm-14 text-black ff-semibold mb-3">
              Service Details <br />
            </p>
            <p className=" font-14 font-sm-12 text-black ff-semibold mb-3 ">
              {applicantLabel}
            </p>
            {Array.isArray(serviceListData) && serviceListData.length > 0 ? (
              <Accordion
                className="accordion"
                activeKey={activeAccordionService}
              >
                {serviceListData &&
                  serviceListData.map((item, index) => (
                    <Accordion.Item
                      key={index}
                      eventKey={`active-service-${index}`}
                      className="mb-3 layout-border rounded-3 serve-details-inside-upload"
                    >
                      <Accordion.Header
                        onClick={() =>
                          handleServiceAccordionToggle(
                            `active-service-${index}`
                          )
                        }
                      >
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <span
                            className="font-14 ff-medium"
                            dangerouslySetInnerHTML={{
                              __html: `${index + 1}. ${
                                item.isPackage
                                  ? item.packageName || "Employee Visa Package"
                                  : item.serviceName || "Service"
                              }`,
                            }}
                          />

                          <div className="ms-auto d-flex align-items-center gap-3">
                            <span className="ff-bold font-13">
                              <span className="ff-currency ff-medium  font-16">
                                
                              </span>
                              {item.isPackage
                                ? item.totalPrice || 0
                                : item.PriceAmount || 0}
                            </span>
                            <div
                              className="d-flex align-items-center justify-content-center upDlt"
                              onClick={(e) => {
                                e.stopPropagation();
                                OpenDeleteModel(
                                  item.cartId,
                                  item.isPackage ? "Package" : "Service"
                                );
                              }}
                            >
                              <img
                                src="https://goodhand.b-cdn.net/Assets/Upload/up-delete.svg"
                                alt="Delete"
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body className="p-0">
                        <div className="accordion-body py-2 px-3">
                          {item.selectedFilter &&
                            item.selectedFilter?.length > 0 && (
                              <div className="pb-3">
                                <p className="ff-medium text-muted font-14 mb-2">
                                  Options Selected
                                </p>
                                <div className="d-flex flex-wrap gap-2 mt-1">
                                  {item.selectedFilter.map((option, optIdx) => (
                                    <div
                                      key={`selected-filter-${optIdx}`}
                                      className="capsule px-2 py-1 rounded-pill bg-3 text-main ff-semibold font-12"
                                      dangerouslySetInnerHTML={{
                                        __html: option,
                                      }}
                                    ></div>
                                  ))}
                                </div>
                              </div>
                            )}

                          {Array.isArray(item.services) &&
                            item.services.length > 0 && (
                              <ul className="list-unstyled mb-0">
                                {item.services.map((service, serviceIndex) => (
                                  <li className="doc-row" key={serviceIndex}>
                                    <div className="font-13 d-flex align-items-center gap-2">
                                      <div className="tick-sv-icon upcoming">
                                        <svg
                                          width="18"
                                          height="19"
                                          viewBox="0 0 18 19"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                            fill="#458E4A"
                                          ></path>
                                        </svg>
                                      </div>
                                      <span
                                        className="each-doc-list"
                                        dangerouslySetInnerHTML={{
                                          __html: service.serviceName,
                                        }}
                                      ></span>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            )}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
              </Accordion>
            ) : (
              <div className="alert alert-info text-center">
                No service details available.
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="p-0 border-0 rounded-0 shadow-none border-top modal-footer">
          <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2">
            <button
              className="btn btn-primary w-100 font-14 ff-semibold py-3  bt--cart"
              onClick={closeModel}
            >
              OkAY, GOT IT
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ServiceListDisplayModel;
